export const TRANSLATIONS_EN = {};
